'use client';

import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { Stack, Typography } from '@packages/shared';
import { Joe, PaybackColored32 } from '@packages/themes/icons';
import { useIntl } from 'react-intl';
import { BonusPointsFragmentFragmentDoc } from '@packages/gql/generated/shopping/BonusPointsFragmentFragmentDoc';
import { bonusPointsMessages } from './messages';

/* GraphQL */ `
  fragment BonusPointsFragment on Bonuspoints {
    points
    type
  }
`;

type BonusPointsProps = {
  data: FragmentType<typeof BonusPointsFragmentFragmentDoc>;
};

/**
 * This component is used to render either Joe or Payback bonus points.
 */
export const BonusPoints = ({ data: bonusPointsData }: BonusPointsProps) => {
  const { points, type } = getFragmentData(BonusPointsFragmentFragmentDoc, bonusPointsData);
  const { formatMessage } = useIntl();

  if (!(type === 'JOE' || type === 'PAYBACK')) return null;

  const Icon = type === 'PAYBACK' ? PaybackColored32 : Joe;

  return (
    <Stack spacing={0.5} direction="row" alignItems="center">
      <Icon sx={{ fontSize: '1rem' }} />
      <Typography component="span" variant="body1" sx={{ fontWeight: 'fontWeightSemiBold' }}>
        {formatMessage(bonusPointsMessages[type], {
          value: points,
        })}
      </Typography>
    </Stack>
  );
};
